import z from "zod";
import { defineObject } from "sanity-typed-queries";
import columnInfoGroupSection from "./columnInfoGroupSection.js";
import arrayEntry from "../fragments/arrayEntry.js";
var schema = defineObject("columnInfoGroup", {
    groups: {
        title: "Groups",
        type: "array",
        of: [
            {
                type: "columnInfoGroupSection"
            }
        ]
    },
    sortDirection: {
        title: "Sort direction",
        type: "string",
        options: {
            list: [
                "horizontal",
                "vertical"
            ]
        }
    }
}, [
    columnInfoGroupSection.schema.columnInfoGroupSection
]);
var validator = z.object({
    _type: z.literal("columnInfoGroup"),
    groups: z.array(columnInfoGroupSection.validator.merge(arrayEntry.validator)).optional(),
    sortDirection: z.enum([
        "horizontal",
        "vertical"
    ]).optional()
});
schema.columnInfoGroup;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=columnInfoGroup.js.map